import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import FransysSignature from '@shared/components/UIElements/FransysSignature.vue';
import LoginBar from '@/components/LoginBar.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createBlock(_component_v_col, { class: "pa-0 my-auto" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "ma-0 pb-12 mx-auto fit-content" }, {
        default: _withCtx(() => [
          _createVNode(FransysSignature)
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "ma-0" }, {
        default: _withCtx(() => [
          _createVNode(LoginBar, { class: "ma-auto" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})